import React from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { Box } from '@mui/material'
import { QuestionState } from '../../../../../../features/types'
import SingleQuestion from '../SingleQuestion'

interface ItemProps {
    id?: string | number
    questionId?: string | number
    name?: string
    type?: string
}

interface QuestionsDndProps {
    formik?: any
    setItems: (elements: any[]) => void
    handleDelete: (index: number) => void
    openDialog: (question: QuestionState) => void
}

const reorder = (list: ItemProps[], startIndex: number, endIndex: number) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)

    result.splice(endIndex, 0, removed)

    return result
}

function Item({
    item,
    index,
    handleDelete,
    openDialog,
    formik,
}: {
    item: QuestionState
    index: number
    handleDelete: (index: number) => void
    openDialog: (question: QuestionState) => void
    formik: any
}) {
    return (
        <Draggable
            draggableId={`question-${item.id || item.questionId}`}
            index={index}
        >
            {(provided, snapshot) => (
                <SingleQuestion
                    innerRef={provided.innerRef}
                    snapshot={snapshot}
                    draggableProps={provided.draggableProps}
                    dragHandleProps={provided.dragHandleProps}
                    index={index}
                    key={item.id}
                    question={item}
                    formik={formik}
                    handleDelete={handleDelete}
                    openDialog={openDialog}
                />
            )}
        </Draggable>
    )
}

const ItemList = React.memo(function ItemList({
    //items,
    handleDelete,
    openDialog,
    formik,
}: any) {
    return formik.values.questions.map((item: QuestionState, index: number) => (
        <Item
            item={item}
            index={index}
            key={`question-${item.id || item.questionId}`}
            handleDelete={handleDelete}
            openDialog={openDialog}
            formik={formik}
        />
    ))
})

function QuestionsDnd({
    setItems,
    handleDelete,
    openDialog,
    formik,
}: QuestionsDndProps) {
    function onDragEnd(result) {
        if (!result.destination) {
            return
        }

        if (result.destination.index === result.source.index) {
            return
        }

        const newItems = reorder(
            formik.values.questions,
            result.source.index,
            result.destination.index,
        )

        setItems(newItems)
    }

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="list">
                {(provided) => (
                    <Box
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        <ItemList
                            formik={formik}
                            handleDelete={handleDelete}
                            openDialog={openDialog}
                        />
                        {provided.placeholder}
                    </Box>
                )}
            </Droppable>
        </DragDropContext>
    )
}

export default QuestionsDnd
